// @ts-nocheck
import React from 'react';
import initialState from '/root/bfe-epc-web/src/.umi-production/plugin-initial-state/models/initialState';
import model0 from "/root/bfe-epc-web/src/models/app";
import model1 from "/root/bfe-epc-web/src/models/common";
import model2 from "/root/bfe-epc-web/src/models/connect";
import model3 from "/root/bfe-epc-web/src/models/data-center-big-screen-filter";
import model4 from "/root/bfe-epc-web/src/models/menu";
import model5 from "/root/bfe-epc-web/src/models/new-all-city-list";
import model6 from "/root/bfe-epc-web/src/models/order-center-commodity-footprint";
import model7 from "/root/bfe-epc-web/src/models/order-center-order-detail-order-status";
import model8 from "/root/bfe-epc-web/src/models/order-center-order-detail";
import model9 from "/root/bfe-epc-web/src/models/order-center-same-city-address-tips";
import model10 from "/root/bfe-epc-web/src/models/order-center-same-city-calc";
import model11 from "/root/bfe-epc-web/src/models/order-center-same-city-car-model-select";
import model12 from "/root/bfe-epc-web/src/models/order-center-same-city-coupon-select";
import model13 from "/root/bfe-epc-web/src/models/order-center-same-city-delivery-car-require";
import model14 from "/root/bfe-epc-web/src/models/order-center-same-city-follower";
import model15 from "/root/bfe-epc-web/src/models/order-center-same-city-handling-service";
import model16 from "/root/bfe-epc-web/src/models/order-center-same-city-order-contact";
import model17 from "/root/bfe-epc-web/src/models/order-center-same-city-order-remark";
import model18 from "/root/bfe-epc-web/src/models/order-center-same-city-pay-type";
import model19 from "/root/bfe-epc-web/src/models/order-center-same-city-predict-config";
import model20 from "/root/bfe-epc-web/src/models/order-center-same-city-quality-service";
import model21 from "/root/bfe-epc-web/src/models/order-center-same-city-rest";
import model22 from "/root/bfe-epc-web/src/models/order-center-same-city-route";
import model23 from "/root/bfe-epc-web/src/models/order-center-same-city-shipping-city";
import model24 from "/root/bfe-epc-web/src/models/order-center-same-city-use-car-goods-info";
import model25 from "/root/bfe-epc-web/src/models/order-center-same-city-use-car-reason";
import model26 from "/root/bfe-epc-web/src/models/order-center-same-city-use-car-time";
import model27 from "/root/bfe-epc-web/src/models/province-city-area";
import model28 from "/root/bfe-epc-web/src/models/service-type-list";
import model29 from "/root/bfe-epc-web/src/models/tags";
// @ts-ignore
import Dispatcher from './helpers/dispatcher';
// @ts-ignore
import Executor from './helpers/executor';
// @ts-ignore
import { UmiContext } from './helpers/constant';

export const models = { '@@initialState': initialState, 'app': model0, 'common': model1, 'order-center-same-city-shipping-city': model23, 'order-center-same-city-car-model-select': model11, 'order-center-same-city-quality-service': model20, 'order-center-same-city-handling-service': model15, 'connect': model2, 'data-center-big-screen-filter': model3, 'menu': model4, 'new-all-city-list': model5, 'order-center-commodity-footprint': model6, 'order-center-order-detail-order-status': model7, 'order-center-order-detail': model8, 'order-center-same-city-address-tips': model9, 'order-center-same-city-route': model22, 'order-center-same-city-use-car-goods-info': model24, 'order-center-same-city-calc': model10, 'order-center-same-city-rest': model21, 'order-center-same-city-coupon-select': model12, 'order-center-same-city-delivery-car-require': model13, 'order-center-same-city-follower': model14, 'order-center-same-city-order-contact': model16, 'order-center-same-city-order-remark': model17, 'order-center-same-city-pay-type': model18, 'order-center-same-city-predict-config': model19, 'order-center-same-city-use-car-reason': model25, 'order-center-same-city-use-car-time': model26, 'province-city-area': model27, 'service-type-list': model28, 'tags': model29 };

export type Model<T extends keyof typeof models> = {
  [key in keyof typeof models]: ReturnType<typeof models[T]>;
};

export type Models<T extends keyof typeof models> = Model<T>[T]

const dispatcher = new Dispatcher!();
const Exe = Executor!;

export default ({ children }: { children: React.ReactNode }) => {

  return (
    <UmiContext.Provider value={dispatcher}>
      {
        Object.entries(models).map(pair => (
          <Exe key={pair[0]} namespace={pair[0]} hook={pair[1] as any} onUpdate={(val: any) => {
            const [ns] = pair as [keyof typeof models, any];
            dispatcher.data[ns] = val;
            dispatcher.update(ns);
          }} />
        ))
      }
      {children}
    </UmiContext.Provider>
  )
}
